module.exports = __webpack_public_path__ + "img/worm-attack-mask-01.a4efbe9d.png";